import React from 'react'
import ADHDApp from '@/components/freetool/adhd'
import ASDApp from '@/components/freetool/asd'

type Tool = 'adhd' | 'asd'

type Props = {
  tool: Tool
  backHref?: string
}

const AssessmentLauncher: React.FC<Props> = ({
  tool,
  backHref = '/adhd-autism-assessment-tool',
}) => {
  return tool === 'adhd' ? (
    <ADHDApp backHref={backHref} />
  ) : (
    <ASDApp backHref={backHref} />
  )
}

export default AssessmentLauncher
